import type {RouteLocationNormalized} from 'vue-router';
import {PortalType} from '@studyportals/domain-client';

export const domainPortalMap: Record<PortalType, string> = {
	[PortalType.MASTER]: 'mastersportal',
	[PortalType.BACHELOR]: 'bachelorsportal',
	[PortalType.PHD]: 'phdportal',
	[PortalType.DISTANCE_LEARNING]: 'distancelearningportal',
	[PortalType.SHORT]: 'shortcoursesportal'
};

export const getPortalTypeFromPath = (to: RouteLocationNormalized): PortalType | null => {
	const domain = to.params.domain as string | undefined;
	if (domain) {
		const normalizedDomain = domain.toLowerCase();

		switch (normalizedDomain) {
		case domainPortalMap[PortalType.MASTER]:
			return PortalType.MASTER;
		case domainPortalMap[PortalType.BACHELOR]:
			return PortalType.BACHELOR;
		case domainPortalMap[PortalType.PHD]:
			return PortalType.PHD;
		case domainPortalMap[PortalType.DISTANCE_LEARNING]:
			return PortalType.DISTANCE_LEARNING;
		case domainPortalMap[PortalType.SHORT]:
			return PortalType.SHORT;
		default:
			return null;
		}
	}

	if (typeof window !== 'undefined') {
		const hostname = window.location.hostname.toLowerCase();

		for (const [portalType, portalDomain] of Object.entries(domainPortalMap)) {
			if (hostname.includes(portalDomain)) {
				return portalType as PortalType;
			}
		}
	}

	return null;
};

export const getPortalPathFromType = (portalType: PortalType): string => {
	switch (portalType) {
	case PortalType.MASTER: return 'master';
	case PortalType.BACHELOR: return 'bachelor';
	case PortalType.PHD: return 'phd';
	case PortalType.DISTANCE_LEARNING: return 'distance-learning';
	case PortalType.SHORT: return 'course';
	default: return 'master';
	}
};
